for (let i = 1; i < 99; i++) {
    let currentElement = document.getElementById('padasnap_slide_01_cus_slid_progress_bar_2_' + i);
    let titleElement = document.getElementById('padasnap_title_slide_01_cus_slide_' + i);
    console.log("padasnap-slide-01.js", currentElement)
    if (currentElement) {

        titleElement.addEventListener('click', function (event) {
            let arr  = titleElement.id.split('_')
            let lastStr = arr[arr.length - 1]

            let current_padasnap_slide_progress_bar_animation = document.querySelectorAll('.padasnap_slide_progress_bar_animation')
            let current_padasnap_slide_display_show = document.querySelectorAll('.padasnap_slide_display_show')
            let current_padasnap_slide_01_cus_slid_title____bold = document.querySelectorAll('.padasnap_slide_01_cus_slid_title____bold')
            let current_padasnap_slide_01_content_video_display_show = document.querySelectorAll('.padasnap_slide_01_content_video_display_show')

            current_padasnap_slide_progress_bar_animation.forEach(e => {
                console.log(e)
                e.classList.remove('padasnap_slide_progress_bar_animation');
            })
            current_padasnap_slide_display_show.forEach(e => {
                e.classList.remove('padasnap_slide_display_show');
            })
            current_padasnap_slide_01_cus_slid_title____bold.forEach(e => {
                e.classList.remove('padasnap_slide_01_cus_slid_title____bold');
            })
            current_padasnap_slide_01_content_video_display_show.forEach(e => {
                e.classList.remove('padasnap_slide_01_content_video_display_show');
            })


            let progress_bar_2_ = document.getElementById('padasnap_slide_01_cus_slid_progress_bar_2_' + lastStr);
            let slide_desc_ = document.getElementById('padasnap_desc_slide_01_cus_slide_desc_' + lastStr)
            let content_video_ = document.getElementById('padasnap_slide_01_content_video_' + lastStr)
            let cus_slide_ = document.getElementById('padasnap_title_slide_01_cus_slide_' + lastStr)

            progress_bar_2_.classList.add('padasnap_slide_progress_bar_animation');
            slide_desc_.classList.add('padasnap_slide_display_show');
            content_video_.classList.add('padasnap_slide_01_content_video_display_show');
            cus_slide_.classList.add("padasnap_slide_01_cus_slid_title____bold")


        })

        currentElement.addEventListener('animationend', function(event) {
            // 移除当前元素的动画类
            currentElement.classList.remove('padasnap_slide_progress_bar_animation');
            let slideDescElement = document.getElementById('padasnap_desc_slide_01_cus_slide_desc_' + i)
            slideDescElement.classList.remove('padasnap_slide_display_show');
            let slideTitleElement = document.getElementById('padasnap_title_slide_01_cus_slide_' + i)
            slideTitleElement.classList.remove('padasnap_slide_01_cus_slid_title____bold');
            let slideVideoDescElement = document.getElementById('padasnap_slide_01_content_video_' + i)
            slideVideoDescElement.classList.remove('padasnap_slide_01_content_video_display_show');


            // 计算下一个元素的索引
            let nextIndex = (i % 98) + 1;
            let nextElement = document.getElementById('padasnap_slide_01_cus_slid_progress_bar_2_' + nextIndex);
            let nextSlideDescElement = document.getElementById('padasnap_desc_slide_01_cus_slide_desc_' + nextIndex)
            let nextVideoSlideDescElement = document.getElementById('padasnap_slide_01_content_video_' + nextIndex)
            let nextSlideTitleElement = document.getElementById('padasnap_title_slide_01_cus_slide_' + nextIndex)

            // 如果下一个元素存在，则添加动画类
            if (nextElement) {
                nextElement.classList.add('padasnap_slide_progress_bar_animation');
                nextSlideDescElement.classList.add('padasnap_slide_display_show');
                nextVideoSlideDescElement.classList.add('padasnap_slide_01_content_video_display_show');
                nextSlideTitleElement.classList.add("padasnap_slide_01_cus_slid_title____bold")
            } else {
                // 如果下一个元素不存在，则将动画类添加回第一个元素
                let firstElement = document.getElementById('padasnap_slide_01_cus_slid_progress_bar_2_1');
                let firstSlideDescElement = document.getElementById('padasnap_desc_slide_01_cus_slide_desc_1');
                let firstVideoSlideDescElement = document.getElementById('padasnap_slide_01_content_video_1');
                let firstSlideTitleElement = document.getElementById('padasnap_title_slide_01_cus_slide_1');

                if (firstElement) {
                    firstElement.classList.add('padasnap_slide_progress_bar_animation');
                    firstSlideDescElement.classList.add('padasnap_slide_display_show');
                    firstVideoSlideDescElement.classList.add('padasnap_slide_01_content_video_display_show');
                    firstSlideTitleElement.classList.add('padasnap_slide_01_cus_slid_title____bold')
                }
            }
        });
        continue;
    }
    break;
}


document.addEventListener('scroll', function (event) {
    document.querySelectorAll("video").forEach(video => {
        if (video.paused) {
            video.play().then(() => {
                console.log(video, "正在播放");
            }).catch(error => {
                console.error("播放失败:", error);
            });
        }
    })
})
